import { Link } from "react-router-dom";
import { topics } from "@/mocks/news";
import { getNewsByTopic } from "@/utils/news";

export default function TopicPicks() {
  return (
    <section className="mt-12">
      <div className="flex items-end justify-between gap-4 mb-5">
        <div>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-5 rounded-full bg-primary-500" />
            <h2 className="text-xl md:text-[22px] font-black text-foreground-950">专题精选</h2>
          </div>
          <p className="mt-2 text-sm text-foreground-500">
            围绕一个事件，把所有相关爆料按时间摆在一起
          </p>
        </div>
        <Link
          to="/topic/topic-2"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          共 {topics.length} 个专题进行中
          <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {topics.map((topic) => {
          const count = getNewsByTopic(topic.id).length;
          return (
            <Link
              key={topic.id}
              to={`/topic/${topic.id}`}
              className="group rounded-lg overflow-hidden border border-background-200/80 bg-background-50 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative w-full h-[168px] overflow-hidden bg-background-200">
                <img
                  src={topic.cover}
                  alt={topic.name}
                  title={`${topic.name} - 专题合集`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent" />
                <span className="absolute left-3 bottom-3 inline-flex items-center gap-1 h-6 px-2 rounded bg-background-50/90 text-primary-700 text-xs font-medium">
                  <i className="ri-folder-open-line" />
                  {count} 条爆料
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {topic.name}
                </h3>
                <p className="mt-1.5 text-[13px] leading-6 text-foreground-600 line-clamp-2-safe">
                  {topic.subtitle}
                </p>
                <div className="mt-3 flex items-center gap-1.5 flex-wrap">
                  {topic.keywords.slice(0, 3).map((word) => (
                    <span
                      key={word}
                      className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-800 text-[11px]"
                    >
                      {word}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}